const URL = {
  GET_SHOP: 'Shop/GetShop',
  EDIT_SHOP: 'Shop/EditShop',
  PATCH_SHOP: 'Shop/PatchShop',
  SHOP_SETUP_STATUS: 'Shop/setup-status',
  SHOP_BRANDING: 'Shop/branding',
  SHOP_BRANDING_CUSTOM_CODE: 'Shop/branding/custom-code',
  SHOP_LANGUAGE: 'Shop/language',
  SHOP_LANGUAGE_TEXTS: 'Shop/language/texts/{languageCode}',
}

export default URL
